module.exports = __webpack_public_path__ + "img/thumbnail_DanubeCrestedNewt_u_normal.0a94575c.png";